"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("@linaria/react");
var _intents = _interopRequireDefault(require("@ux/intents"));
var _core = require("@linaria/core");
"l5umhu9";
const intents = new _intents.default();
const LtoCardStyle = /*#__PURE__*/(0, _react.styled)("div")({
  name: "LtoCardStyle",
  class: "l1jgzvyu"
});
var _default = exports.default = LtoCardStyle;